import type { Resource } from '../../';
export const product_sizeChart_ages_littleKids: Resource = {"default":"5 - 7.5 Years"};
